(function() {
  'use strict';

  function handleize(str) {
    return (str || '')
      .toString()
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function initColorDrawer() {
    const drawer = document.querySelector('[data-color-drawer]');
    const openButton = document.querySelector('[data-color-picker-more]');
    const closeButton = document.querySelector('[data-color-drawer-close]');
    const overlay = document.querySelector('[data-color-drawer-overlay]');
    const items = document.querySelectorAll('[data-color-drawer-item]');

    if (!drawer || !openButton) return;

    function openDrawer() {
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openButton.addEventListener('click', openDrawer);
    if (closeButton) closeButton.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    items.forEach(function(item) {
      item.addEventListener('click', function() {
        // Bloquer si incompatible
        if (item.classList.contains('color-drawer__item--incompat')) return;
        const value = item.getAttribute('data-color-value');
        const radios = document.querySelectorAll('.product-form__input--color input[type="radio"]');
        radios.forEach(function(radio) {
          if (radio.value === value) radio.click();
        });
        closeDrawer();
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      }
    });
  }

  function initColorDependencies() {
  // Cible le picker principal (pas sticky)
  const allColorFieldsets = document.querySelectorAll('.product-form__input--color');
  let colorFieldset = null;
  for (let i = 0; i < allColorFieldsets.length; i++) {
    const fs = allColorFieldsets[i];
    const input = fs.querySelector('input[type="radio"]');
    if (input && input.name && input.name.indexOf('--sticky') === -1) {
      colorFieldset = fs;
      break;
    }
  }
  if (!colorFieldset && allColorFieldsets.length) colorFieldset = allColorFieldsets[0];
  if (!colorFieldset) return;

  // Scope : on reste dans le même <product-form> / <form> que le picker
  const scope = colorFieldset.closest('product-form') ||
                colorFieldset.closest('form') ||
                colorFieldset.parentElement;

  const allFieldsets = scope.querySelectorAll('.product-form__input[data-handle]');
  const otherFieldsets = Array.from(allFieldsets).filter(function(f) {
    return !f.classList.contains('product-form__input--color');
  });
  if (otherFieldsets.length === 0) return;

  const MAX_VISIBLE = 4;
  const MAX_VISIBLE_MOBILE = 3;

  function getActiveOtherValues() {
    const values = [];
    otherFieldsets.forEach(function(fs) {
      const checked = fs.querySelector('input[type="radio"]:checked');
      const select = fs.querySelector('select');
      if (checked) values.push(handleize(checked.value));
      else if (select) values.push(handleize(select.value));
    });
    return values;
  }

  function isCompat(el, activeValues) {
    const attr = el.getAttribute('data-compat') || '';
    if (!attr) return true;
    const tuples = attr.split(',').map(function(t) { return t.split(':'); });
    return tuples.some(function(tuple) {
      return activeValues.every(function(av) { return tuple.indexOf(av) !== -1; });
    });
  }

  function updateColorAvailability() {
    const activeValues = getActiveOtherValues();
    if (activeValues.length === 0) return;

    const labels = colorFieldset.querySelectorAll('label[for]');
    let firstValidRadio = null;
    let currentSelectedInvalid = false;
    let validIdx = 0;

    labels.forEach(function(label) {
      const input = document.getElementById(label.getAttribute('for'));
      const compat = isCompat(label, activeValues);

      if (!compat) {
        label.style.display = 'none';
        label.classList.add('color-swatch--incompat');
        if (input && input.checked) currentSelectedInvalid = true;
        return;
      }

      label.classList.remove('color-swatch--incompat');
      if (firstValidRadio === null && input) firstValidRadio = input;

      if (validIdx >= MAX_VISIBLE) {
        label.style.display = 'none';
        label.classList.remove('color-swatch--desktop-only');
      } else if (validIdx >= MAX_VISIBLE_MOBILE) {
        label.style.display = '';
        label.classList.add('color-swatch--desktop-only');
      } else {
        label.style.display = '';
        label.classList.remove('color-swatch--desktop-only');
      }
      validIdx++;
    });

    const totalValid = validIdx;
    const remainingDesktop = Math.max(0, totalValid - MAX_VISIBLE);
    const remainingMobile = Math.max(0, totalValid - MAX_VISIBLE_MOBILE);

    const moreBtn = colorFieldset.querySelector('[data-color-picker-more]');
    if (moreBtn) {
      const dCount = moreBtn.querySelector('.color-picker__more-count--desktop');
      const mCount = moreBtn.querySelector('.color-picker__more-count--mobile');
      if (dCount) dCount.textContent = remainingDesktop;
      if (mCount) mCount.textContent = remainingMobile;
      moreBtn.style.display = remainingMobile > 0 ? '' : 'none';
    }

    document.querySelectorAll('[data-color-drawer-item]').forEach(function(item) {
  item.style.display = isCompat(item, activeValues) ? '' : 'none';
});

    if (currentSelectedInvalid && firstValidRadio && !firstValidRadio.checked) {
      firstValidRadio.click();
    }
  }

  otherFieldsets.forEach(function(fs) {
    fs.querySelectorAll('input[type="radio"]').forEach(function(r) {
      r.addEventListener('change', updateColorAvailability);
    });
    fs.querySelectorAll('select').forEach(function(s) {
      s.addEventListener('change', updateColorAvailability);
    });
  });

  updateColorAvailability();
}

  function init() {
    initColorDrawer();
    initColorDependencies();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();